import { Heading, Text } from "@chakra-ui/react";
import { ModalConfirm } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { useCallback } from "react";

type ExternalLinkModalProps = {
  readonly url: string;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onConfirm?: () => void;
};

export const ExternalLinkModal = ({
  url,
  isOpen,
  onClose,
  onConfirm,
}: ExternalLinkModalProps) => {
  const handleOnConfirm = useCallback(() => {
    onConfirm?.();
    window.open(url, "_blank", "noopener,noreferrer");
  }, [url, onConfirm]);

  return (
    <ModalConfirm
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleOnConfirm}
      heading={t`Leaving Allfred`}
      message={
        <>
          <Trans>
            <Heading as="h5" mb="2" size="sm">
              You are leaving Allfred
            </Heading>
            <Text>
              You will be redirected to{" "}
              <strong className="underline">{url}</strong>.
            </Text>
          </Trans>
        </>
      }
      confirmBtnTitle={t`Redirect`}
      cancelBtnTitle={t`Cancel`}
    />
  );
};
